import { Prompt, PromptHeader } from 'common/styles';
import lang from 'common/lang';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useUpdateDeliveryAddressMutation } from 'features/gifting/giftingSevice';
import { cleanPhoneNumber } from 'common/utils/helpers';
import Typography from '../typography';
import { CloseIcon } from '../iconComponents';
import Button from '../button/button';
import { deliveryAddressModalProps } from './type';
import { Deliveryschema } from './validationSchema';
import { ControlledInputText } from '../input';
import { FormWrapper, InputContainer } from './styles';
import useAlert from '../alert/useAlert';

const { deliveryAddressModal } = lang;

export const DeliveryAddressModal = ({
  closeModal, isEditModal, recipient, connectionId, refetch, setAlertState,
}:deliveryAddressModalProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(Deliveryschema),
    defaultValues: {
      name: recipient.name,
      phoneNumber: cleanPhoneNumber(recipient.phone),
      street1: recipient.street1 || '',
      street2: recipient.street2 || '',
      city: recipient.city || '',
      state: recipient.state || '',
      zipCode: recipient.zipCode || '',
    },
  });

  const [trigger, { isLoading }] = useUpdateDeliveryAddressMutation();

  const onSubmit = (data: any) => {
    trigger({
      ...data,
      connectionId,
      employeeId: recipient.id,
      street_1: data.street1,
      street_2: data.street2,
    }).unwrap().then(() => {
      refetch();
      setAlertState({
        show: true,
        type: 'success',
        title: '',
        content: deliveryAddressModal.success,
        variant: 'floating',
      });
      closeModal(false);
    }).catch((error) => {
      setAlertState({
        variant: 'floating',
        show: true,
        type: 'error',
        title: '',
        content: error.data?.message || '',
      });
      closeModal(false);
    });
  };

  return (
    <Prompt>
      <PromptHeader>
        <Typography variant="heading-03" data-cy="confirm-cancel">
          { `${isEditModal ? deliveryAddressModal.editAddress : deliveryAddressModal.add} ${deliveryAddressModal.title}`}
        </Typography>
        <CloseIcon data-cy="close-icon" onClick={() => closeModal(false)} />
      </PromptHeader>

      <FormWrapper onSubmit={handleSubmit(onSubmit)}>
        <InputContainer>
          <ControlledInputText
            name="name"
            control={control}
            type="text"
            labelText="Name"
            placeholder="Enter your full name"
          />
        </InputContainer>
        <ControlledInputText
          name="phoneNumber"
          control={control}
          type="tel"
          labelText="Phone"
          placeholder="Enter your phone number"

        />
        <ControlledInputText
          name="street1"
          control={control}
          type="text"
          labelText="Street 1"
          placeholder="Enter street line 1"

        />
        <ControlledInputText
          name="street2"
          control={control}
          type="text"
          labelText="Street 2 (optional)"
          placeholder="Enter street 2"

        />
        <InputContainer>
          <ControlledInputText
            name="city"
            control={control}
            type="text"
            labelText="City"
            placeholder="Enter city"

          />
          <ControlledInputText
            name="zipCode"
            control={control}
            type="text"
            labelText="Postal Code"
            placeholder="Enter zipcode"

          />
        </InputContainer>
        <ControlledInputText
          name="state"
          control={control}
          type="text"
          labelText="State"
          placeholder="Enter State"
        />
        <div className="button-container">
          <Button
            label={deliveryAddressModal.cancelChanges}
            variant="outlined"
            data-cy="button-not-now"
            onClick={() => closeModal(false)}
            disabled={isLoading}

          />
          <Button
            type="submit"
            label={deliveryAddressModal.saveChanges}
            data-cy="button-cancel-plan"
            disabled={isLoading}
          />
        </div>
      </FormWrapper>
    </Prompt>
  );
};
